import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-navy-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yfcp5gvkz9lo">
        <div className="text-center" data-id="element-22" data-mp="1aogvsfbh86cb">
          <span className="metal inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-navy-950" data-id="element-23" data-mp="1apidv3qwtt3j">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgr2vnr2rvpc" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-25" data-mp="1eq2am67kmup5">
            The {totalBonuses} exclusive bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qyddmcjt1i1v">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-silver-400/20 bg-navy-800 p-6 shadow-lg shadow-black/20 ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29r1n4xwf2gnn" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vrscseuw6grl">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="20reogjv2noya">
                    <span className="metal flex h-10 w-10 items-center justify-center rounded-lg text-navy-950" data-id="element-30" data-mp="20ptuavco680y">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25oesyqc9wjna" />
                    </span>
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-silver-300" data-id="element-32" data-mp="3c6ae10v9batm">Bonus {bonus.number}</p>
                  </div>
                  <p className="whitespace-nowrap text-xs font-bold text-silver-300" data-id="element-33" data-mp="1h2vtuz4phx4a">
                    <span className="line-through" data-id="element-34" data-mp="1c4aq4pq8wvb3">Real value {bonus.value}</span>
                    <span className="metal ml-2 rounded-md px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-navy-950" data-id="element-35" data-mp="1c6ol6ykxe7in">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-bold leading-tight text-white" data-id="element-36" data-mp="yce515mzvlo7">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-silver-300" data-id="element-37" data-mp="teckshdu1gb5">{bonus.description}</p>

                {bonus.items && <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-38" data-mp="176shz1k1yk45">
                    {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-silver-100" data-id="element-39" data-mp="12cehwlug3ot5">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-silver-300" aria-hidden="true" data-id="element-40" data-mp="emtwzxeqehh8" />
                        {item}
                      </li>)}
                  </ul>}

                <div className="flex-1" data-id="element-41" data-mp="5a4olgmd66q6" />
                <p className="mt-4 rounded-lg border-l-4 border-silver-300 bg-navy-900 px-4 py-3 text-sm font-semibold text-silver-100" data-id="element-42" data-mp="5awjep8500fe">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border border-silver-400/30 bg-navy-950 px-6 py-6 text-center shadow-lg shadow-black/30 sm:flex-row sm:text-left" data-id="element-43" data-mp="ja5mqob8v01y">
          <div data-id="element-44" data-mp="9bygp0ihu2eq">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-silver-300" data-id="element-45" data-mp="9chpnrq61ggm">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 text-2xl font-extrabold text-silver-400 line-through decoration-red-400 decoration-2" data-id="element-46" data-mp="ecm8vpigkpaj">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-47" data-mp="2z2bow5uweh4t">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-silver-300" data-id="element-48" data-mp="3f7wrlljy5off">Your price today</p>
            <p className="metal-text mt-1 text-3xl font-extrabold" data-id="element-49" data-mp="3agwv2heqp8dg">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-silver-300" data-id="element-50" data-mp="35hk7fug1nx9t">
          Only included in this offer
        </p>
      </div>
    </section>;
}